import { makeStyles, tokens } from '@fluentui/react-components';

export const useHealthGoalCardStyles = makeStyles({
  card: {
    padding: tokens.spacingVerticalL,
  },
});
